import { COLOR_PALETTE } from './color-pallete.constant';
import type { ITheme } from './theme.interface';

export const lightTheme: ITheme = {
  '--unity-black-0': COLOR_PALETTE.BLACK_0,
  '--unity-black-1': COLOR_PALETTE.BLACK_1,
  '--unity-black-2': COLOR_PALETTE.BLACK_2,
  '--unity-black-3': COLOR_PALETTE.BLACK_3,
  '--unity-black-4': COLOR_PALETTE.BLACK_4,
  '--unity-black-5': COLOR_PALETTE.BLACK_5,
  '--unity-black-6': COLOR_PALETTE.BLACK_6,
  '--unity-black-7': COLOR_PALETTE.BLACK_7,
  '--unity-black-8': COLOR_PALETTE.BLACK_8,

  '--unity-blue-0': COLOR_PALETTE.BLUE_0,
  '--unity-blue-1': COLOR_PALETTE.BLUE_1,
  '--unity-blue-2': COLOR_PALETTE.BLUE_2,
  '--unity-blue-3': COLOR_PALETTE.BLUE_3,
  '--unity-blue-4': COLOR_PALETTE.BLUE_4,
  '--unity-blue-5': COLOR_PALETTE.BLUE_5,
  '--unity-blue-6': COLOR_PALETTE.BLUE_6,
  '--unity-blue-7': COLOR_PALETTE.BLUE_7,
  '--unity-blue-8': COLOR_PALETTE.BLUE_8,
  '--unity-blue-9': COLOR_PALETTE.BLUE_9,
  '--unity-blue-10': COLOR_PALETTE.BLUE_10,
  '--unity-blue-11': COLOR_PALETTE.BLUE_11,

  '--unity-cool-gray-0': COLOR_PALETTE.COOL_GRAY_0,
  '--unity-cool-gray-1': COLOR_PALETTE.COOL_GRAY_1,
  '--unity-cool-gray-2': COLOR_PALETTE.COOL_GRAY_2,
  '--unity-cool-gray-3': COLOR_PALETTE.COOL_GRAY_3,
  '--unity-cool-gray-4': COLOR_PALETTE.COOL_GRAY_4,
  '--unity-cool-gray-5': COLOR_PALETTE.COOL_GRAY_5,
  '--unity-cool-gray-6': COLOR_PALETTE.COOL_GRAY_6,
  '--unity-cool-gray-7': COLOR_PALETTE.COOL_GRAY_7,
  '--unity-cool-gray-8': COLOR_PALETTE.COOL_GRAY_8,
  '--unity-cool-gray-9': COLOR_PALETTE.COOL_GRAY_9,
  '--unity-cool-gray-10': COLOR_PALETTE.COOL_GRAY_10,
  '--unity-cool-gray-11': COLOR_PALETTE.COOL_GRAY_11,
  '--unity-cool-gray-12': COLOR_PALETTE.COOL_GRAY_12,
  '--unity-cool-gray-13': COLOR_PALETTE.COOL_GRAY_13,
  '--unity-cool-gray-14': COLOR_PALETTE.COOL_GRAY_14,
  '--unity-cool-gray-15': COLOR_PALETTE.COOL_GRAY_15,
  '--unity-cool-gray-16': COLOR_PALETTE.COOL_GRAY_16,
  '--unity-cool-gray-17': COLOR_PALETTE.COOL_GRAY_17,
  '--unity-cool-gray-18': COLOR_PALETTE.COOL_GRAY_18,
  '--unity-cool-gray-19': COLOR_PALETTE.COOL_GRAY_19,
  '--unity-cool-gray-20': COLOR_PALETTE.COOL_GRAY_20,

  '--unity-green-0': COLOR_PALETTE.GREEN_0,
  '--unity-green-1': COLOR_PALETTE.GREEN_1,
  '--unity-green-2': COLOR_PALETTE.GREEN_2,
  '--unity-green-3': COLOR_PALETTE.GREEN_3,
  '--unity-green-4': COLOR_PALETTE.GREEN_4,
  '--unity-green-5': COLOR_PALETTE.GREEN_5,
  '--unity-green-6': COLOR_PALETTE.GREEN_6,
  '--unity-green-7': COLOR_PALETTE.GREEN_7,
  '--unity-green-8': COLOR_PALETTE.GREEN_8,
  '--unity-green-9': COLOR_PALETTE.GREEN_9,

  '--unity-orange-0': COLOR_PALETTE.ORANGE_0,
  '--unity-yellow-0': COLOR_PALETTE.YELLOW_0,

  '--unity-red-0': COLOR_PALETTE.RED_0,
  '--unity-red-1': COLOR_PALETTE.RED_1,
  '--unity-red-2': COLOR_PALETTE.RED_2,
  '--unity-red-3': COLOR_PALETTE.RED_3,
  '--unity-red-4': COLOR_PALETTE.RED_4,

  '--unity-transparent': COLOR_PALETTE.TRANSPARENT,

  '--unity-white-0': COLOR_PALETTE.WHITE_0,
  '--unity-white-1': COLOR_PALETTE.WHITE_1,
  '--unity-white-2': COLOR_PALETTE.WHITE_2,

  '--unity-black-section-bg-color': COLOR_PALETTE.BLACK_0,
  '--unity-blue-section-bg-color': COLOR_PALETTE.BLUE_7,
  '--unity-gradient-section-bg-color': `radial-gradient(54.77% 286.12% at 88.71% -23.93%, #648da34c 0%, #2e414b23 50.38%, #00000000 100%), radial-gradient(56.52% 118.16% at 33.95% -13.66%, #648da3b2 0%, #2e414b51 50.38%, #00000000 100%), radial-gradient(51.34% 93.67% at 54.92% -11.43%, #17c989 0%, #11674aa0 43.87%, #0832244e 72.5%, #00000000 100%), #000000`,
  '--unity-gray-section-bg-color': COLOR_PALETTE.COOL_GRAY_5,
  '--unity-green-section-bg-color': COLOR_PALETTE.GREEN_0,
  '--unity-teal-section-bg-color': COLOR_PALETTE.GREEN_3,
  '--unity-white-section-bg-color': COLOR_PALETTE.WHITE_0,
  '--unity-gray2-section-bg-color': COLOR_PALETTE.COOL_GRAY_17,
};
